import LyPower from './src/index.vue'

LyPower.install = function (Vue) {
    Vue.component(LyPower.name, LyPower)
}

export default LyPower



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/power/index.js
// module id = null
// module chunks = 